import clsx from 'clsx'
import React from 'react'

export type PortalHeaderDetailProps = {
	label?: string
	value?: string
	className?: string
	children?: React.ReactNode
}

const PortalHeaderDetail = ({
	label,
	value,
	className,
	children,
}: PortalHeaderDetailProps) => {
	return (
		<p className={clsx('dark:text-white mt-1', className)}>
			{label && (
				<span className="text-slate-500 dark:text-slate-400">
					{label}
					{': '}
				</span>
			)}
			{value && <span className="font-bold">{value}</span>}
			{children}
		</p>
	)
}

export default PortalHeaderDetail
